"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorPageLayout = require("./ErrorPageLayout");
Object.keys(_ErrorPageLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPageLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPageLayout[key];
    }
  });
});
var _ErrorPageLayoutFeature = require("./ErrorPageLayoutFeature");
Object.keys(_ErrorPageLayoutFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPageLayoutFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPageLayoutFeature[key];
    }
  });
});
